<template>
    <div id="footerDiv">
        <div class="grey-section">
            <div class="container">
                <div class="row">
                    <div class="col-sm-3">
                        <p>ABOUT LABOTIST</p>
                        <ul>
                            <li>
                                <router-link to="/about-us">About Us </router-link>
                            </li>
                            <li>
                                <router-link to="/contact-us">Contact Us</router-link>
                            </li>
                            <li>
                                <router-link to="/privacy-policy">Privacy Policy</router-link>
                            </li>
                            <li>
                                <router-link to="/terms">Terms & Conditions</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-3">
                        <p>JOIN US</p>
                        <ul>
                            <li>
                                <router-link to="/lab-signup">Lab Sign Up</router-link>
                            </li>
                            <li>
                                <router-link to="/phlebotomist-signup">Phlebotomist Sign Up</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-3">
                        <p>FOLLOW US</p>
                        <ul class="social-link">
                            <li>
                                <a href="https://www.facebook.com/labotist" onclick="window.open(this.href); return false;" onkeypress="window.open(this.href); return false;">
                                    <span class="sprites sprite-facebook"></span>
                                </a>
                            </li>
                            <li>
                                <a href="https://twitter.com/labotist" onclick="window.open(this.href); return false;" onkeypress="window.open(this.href); return false;">
                                    <span class="sprites sprite-twitter"></span>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/labotist/?hl=en" onclick="window.open(this.href); return false;" onkeypress="window.open(this.href); return false;">
                                    <span class="sprites sprite-instagram"></span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-sm-3">
                        <p>Newsletter Sign Up</p>
                        <div class="subscribe">
                            <form data-vv-scope="newsletter">
                                <input class="form-control" type="email" name="email" v-model="newsLetterEmail" data-vv-as="email address" v-validate="'required|email|max:200'" placeholder="Enter your email address">
                                <span v-show="errors.has('newsletter.email')" class="help is-danger">{{ errors.first('newsletter.email') }}</span>
                                <button class="btn btn-primary" :disabled="errors.has('newsletter.email')" @click.prevent="saveNewsLetter()">SUBSCRIBE</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--<div class="footer-white">
            <div class="container">
                <div class="row capitalize">
                    <div class="col-sm-3">
                        <ul>
                            <li><a target="_new" href="https://labotist.com/blog/index.php/how-to-check-pregnancy-at-home-without-a-kit/">Pregnancy Test at home</a></li>
                            <li><a target="_new" href="https://labotist.com/blog/index.php/">Fertility test for men</a></li>
                            <li><a target="_new" href="https://labotist.com/blog/index.php/">Sexually Transmitted DIseases</a></li>
                        </ul>
                    </div>
                    <div class="col-sm-3">
                        <ul>
                            <li><a target="_new" href="https://labotist.com/blog/index.php/lorem-ipsum-dolor-sit-amet-a-lorem-ipsum-dolor-sit-amet/">MRI Scan</a></li>
                            <li><a target="_new" href="https://labotist.com/blog/index.php/">Sperm for analysis</a></li>
                            <li><a target="_new" href="https://labotist.com/blog/index.php/">Alchohol Testing Methods</a></li>
                        </ul>
                    </div>
                    <div class="col-sm-3">
                        <ul>
                            <li><a target="_new" href="https://labotist.com/blog/index.php/">Semen Analysis</a></li>
                            <li><a target="_new" href="https://labotist.com/blog/index.php/">HIV Test Report</a></li>
                        </ul>
                    </div>
                    <div class="col-sm-3">
                        <ul>
                            <li><a target="_new" href="https://labotist.com/blog/index.php/">Thyroid Function Tests</a></li>
                            <li><a target="_new" href="https://labotist.com/blog/index.php/">HIV test</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>-->

        <div class="copy-right text-center">
            <p>2017 labotist . All rights reserved.</p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'FooterVue',
  beforeCreate () { },
  data () {
    return {
      newsLetterEmail: ''
    }
  },
  methods: {
    saveNewsLetter: function () {
      this.$validator.validateAll('newsletter').then((result) => {
        if (result) {
          try {
            var data = {
              email: this.newsLetterEmail
            }
            Promise.resolve(this.$POST('patient/newsSubscriber', data)).then(function (res) {
              if (res.response_code === 0) {
                this.$Simplert.open({
                  title: 'Success',
                  message: `Thanks for signup newsletter`,
                  type: 'success',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false
                })
                // alert('Thanks for signup newsletter')
              } else {
                this.$Simplert.open({
                  message: res.response_message,
                  type: 'success',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false
                })
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
            })
          } catch (e) {
            console.error(e)
          }
        }
      }).catch(() => {
        console.log('error exist while save news letter', this.errors)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.help.is-danger {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/web/Footer.vue